import _get from 'lodash/get';
import { createEntityDescriptor } from '../../redux/entity-descriptor';

export default {
  cars: createEntityDescriptor('cars', {
    list: {
      url: '/api/items.json',
      defaultFilters: {
        filters: { type: 'car' },
        limit: 30,
      },
    },
    create: {
      url: '/api/items.json',
    },
    update: {
      url: '/api/items/${entity.id}.json',
    },
    delete: {
      url: '/api/items/${entity.id}.json',
    },
    data: {
      url: '/api/items/${options.id}.json',
      getDefaultData: state => {
        const projectSettings = _get(state, 'settings.data.currency') || _get(state, 'data.projectConfig.data');

        return {
          categoryPath: ',0,0000000006,',
          type: 'car',
          descriptionType: 'text',
          category: { id: '0000000006', path: ',0,0000000006,' },
          pricing: { currency: projectSettings.currency },
          stock: { onlineStock: 1 },
          attributes: [],
          assets: {},
          cmsDescription: [],
        };
      },
    },
  }),
  category: createEntityDescriptor('category', {
    list: {
      url: '/api/categories.json',
      defaultFilters: {
        limit: 999,
      },
    },
    data: {
      url: '/api/categories/${options.id}.json',
    },
  }),
};
